(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filters-by-stone"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('filters-by-stone')) {
    class FiltersByStone extends HTMLElement {
      constructor() {
        super();
        this.onChange = this.onChange.bind(this);
        this.onReset = this.onReset.bind(this);
      }

      connectedCallback() {
        this.filterParam = this.dataset.filterParam;
        this.form = this.querySelector('form');
        this.resetButton = this.querySelector('[data-reset-filter]');

        if (this.form) {
          this.form.addEventListener('change', this.onChange);
        }

        if (this.resetButton) {
          this.resetButton.addEventListener('click', this.onReset);
        }
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener('change', this.onChange);
        }

        if (this.resetButton) {
          this.resetButton.removeEventListener('click', this.onReset);
        }
      }

      updateActiveState(activeValue) {
        this.querySelectorAll('.filters-by-stone__tile').forEach((tile) => {
          const input = tile.querySelector('input[type="radio"]');
          if (! input) return;
          


          const isActive = activeValue !== null && input.value === activeValue;
          tile.classList.toggle('is-active', isActive);
          input.checked = isActive;
        });

        const resetButton = this.querySelector('[data-reset-filter]');
        if (resetButton) {
          resetButton.style.display = activeValue !== null
            ? ''
            : 'none';
        }
      }

      onChange(event) {
        const input = event.target.closest('input[type="radio"]');

        if (! input || input.disabled || !this.filterParam) return;
        


        this.updateActiveState(input.value);

        const url = new URL(window.location.href);
        url.searchParams.delete(this.filterParam);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        url.searchParams.append(this.filterParam, input.value);

        this.renderProductGrid(url);
      }

      onReset() {
        if (!this.filterParam) return;
        


        this.updateActiveState(null);

        const url = new URL(window.location.href);
        url.searchParams.delete(this.filterParam);
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');

        this.renderProductGrid(url);
      }

      async renderProductGrid(url, updateHistory = true) {
        const productGrid = document.getElementById('product-grid');
        const productGridContainer = document.getElementById('ProductGridContainer');

        if (! productGrid || ! productGridContainer || ! productGrid.dataset.id) {
          window.location.href = url.toString();
          return;
        }

        this.classList.add('is-loading');
        productGridContainer.classList.add('loading');

        try {
          const productGridUrl = new URL(url.toString());
          productGridUrl.searchParams.set('section_id', productGrid.dataset.id);

          const response = await fetch(productGridUrl);

          if (! response.ok) {
            throw new Error('Section rendering failed');
          }

          const html = await response.text();
          const parser = new DOMParser();
          const productGridHtml = parser.parseFromString(html, 'text/html');
          const nextProductGridContainer = productGridHtml.getElementById('ProductGridContainer');

          if (! nextProductGridContainer) {
            throw new Error('Product grid container not found');
          }

          productGridContainer.innerHTML = nextProductGridContainer.innerHTML;
          this.classList.remove('is-loading');

          if (updateHistory) {
            history.pushState({filtersByStone: true}, '', `${
              url.pathname
            }${
              url.search
            }`);
          }

          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(document.getElementById('ProductGridContainer'));
          }
        } catch (error) {
          window.location.href = url.toString();
        }
      }
    }

    customElements.define('filters-by-stone', FiltersByStone);

    window.addEventListener('popstate', () => {
      const section = document.querySelector('filters-by-stone');
      if (! section) return;
      


      const url = new URL(window.location.href);
      const activeValue = url.searchParams.get(section.filterParam) || null;
      section.updateActiveState(activeValue);
      section.renderProductGrid(url, false);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
